module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-minus-3f94dcaa.svg";